/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace Matrix.Indexation {

    @Serenity.Decorators.registerEditor("Matrix.Indexation.IndexationProfileSecuritiesEditGrid")
    export class IndexationProfileSecuritiesEditGrid extends Common.GridEditorBase<IndexationProfileSecurityRow> {
        protected getColumnsKey() { return IndexationProfileSecurityColumns.columnsKey; }
        protected getDialogType() { return IndexationProfileSecuritiesEditDialog; }
        protected getIdProperty() { return IndexationProfileSecurityRow.idProperty; }
        protected getInsertPermission() { return IndexationProfileSecurityRow.insertPermission; }
        protected getLocalTextPrefix() { return IndexationProfileSecurityRow.localTextPrefix; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this, {
                selectable: x => !this.readOnly
            });

            this.slickContainer.on('change', '.edit:input', this.inputsChange.bind(this));
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.enableAsyncPostRender = true;
            opt.enableAsyncPostRenderCleanup = true;
            opt.asyncPostRenderDelay = -1;
            return opt;
        }

        protected getColumns() {
            var columns = super.getColumns();
            var rowSelectColumn = Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection);
            rowSelectColumn.headerFilterType = Serenity.HeaderFilterType.disabled;
            columns.splice(0, 0, rowSelectColumn);

            var indexCode = Q.tryFirst(columns, x => x.field == IndexationProfileSecurityRow.Fields.IndexCode);
            if (indexCode) {
                indexCode.width = 300;
                indexCode.format = ctx => Q.lookupEdit(ctx, {
                    widget: FormatLookupEditor,
                    readOnly: this.readOnly
                });
            }

            return columns;
        }

        protected getPersistanceStorage() {
            return null;
        }

        protected getInitialTitle() {
            return null;
        }

        private _indexationProfileCode: string;

        get indexationProfileCode(): string {
            return this._indexationProfileCode;
        }

        set indexationProfileCode(value: string) {
            if (this._indexationProfileCode != value) {
                this._indexationProfileCode = value;
            }
        }

        protected getButtons(): Serenity.ToolButton[] {
            return [
                {
                    title: 'Add Securities',
                    cssClass: 'add-securities-button',
                    icon: 'fa-search-plus',
                    disabled: () => !!this.readOnly,
                    onClick: () => {
                        var dlg = new IndexationProfileSecuritiesPickerDialog();
                        dlg.onSuccess = (selected, indexCode) => {

                            var existing: Q.Dictionary<IndexationProfileSecurityRow> = {};
                            for (let x of this.view.getItems())
                                existing[x.SecurityId] = x;

                            for (let s of selected)
                                if (!existing[s.SecurityId]) {
                                    var item = <IndexationProfileSecurityRow>{
                                        SecurityId: s.SecurityId,
                                        SecurityCode: s.SecurityCode,
                                        SecurityName: s.Name,
                                        DefaultSortOrder: 0,
                                        IndexCode: indexCode,
                                        [this.getIdProperty()]: this.getNextId(),
                                    };
                                    existing[s.SecurityId] = item;
                                    this.view.addItem(item);
                                }

                            return true;
                        };

                        dlg.dialogOpen();
                    }
                }, {
                    title: 'Remove Selected',
                    cssClass: 'remove-selected-button',
                    icon: 'fa-times',
                    disabled: () => !!this.readOnly,
                    onClick: () => {
                        var remove: Q.Dictionary<boolean> = {};
                        var keys = this.rowSelection.getSelectedAsInt64();
                        if (!keys.length) {
                            Q.notifyWarning("Please select securities to remove!");
                            return;
                        }
                        for (var k of keys) {
                            remove[k] = true;
                        }
                        var value = (this.value || []).filter(x => !remove[x[this.getIdProperty()]]);
                        this.value = value;
                        this.rowSelection.setSelectedKeys([]);
                    }
                }, {
                    title: '',
                    hint: 'Excel',
                    cssClass: 'export-xlsx-button',
                    icon: 'fa-file-excel-o',
                    onClick: () => {
                        if (!this.indexationProfileCode)
                            return;

                        var cols = this.slickGrid.getColumns().map(x => x.field).filter(x => x && x != '__select__');
                        cols.push(IndexationProfileSecurityRow.Fields.IndexName);

                        Q.postToService({
                            service: IndexationProfileSecurityService.baseUrl + '/ListExcel',
                            request: <Serenity.ListRequest>{
                                EqualityFilter: {
                                    IndexationProfileCode: this.indexationProfileCode,
                                },
                                ExportColumns: cols,
                                IncludeColumns: cols
                            },
                            target: '_blank'
                        });
                    }
                }];
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row) as IndexationProfileSecurityRow;
            var input = $(e.target);
            var field = input.data('field');

            item[field] = input.val();
            this.view.updateItem(item[this.getIdProperty()], item);
            this.slickGrid.invalidate();
        }

        protected usePager() {
            return false;
        }

        set_readOnly(value) {
            super.set_readOnly(value);
            this.slickGrid.invalidate();
        }
    }
}